import { useState } from 'react';
import useOnceEffect from './useOnceEffect';

const useBaseURL = () => {
    const [url, setURl] = useState("")

    useOnceEffect(() => {

        let is_mounted = true

        const role = localStorage.getItem("rol");

        if(is_mounted) {

        
            switch (role) {
                case "applicant":
                    setURl("user");
                    break;
                case "company":
                    setURl("company")
                    break;
                case "institute":
                    setURl("CentroFormacion")
                    break;

                default:

                    break;
            }
        }


        return () => {
            is_mounted = false
        }
    })
    return url;
};

export default useBaseURL;